import { Checkmark, Close } from '@carbon/icons-react';
import { styled } from '@mui/joy/styles';
import styleToCss from 'style-object-to-css-string';

interface ChecklistItemProps {
  error?: boolean;
  label: string;
  empty?: boolean;
}

const ChecklistItem = ({ error, label, empty }: ChecklistItemProps): JSX.Element => (
  <Box>
    <Circle error={error} empty={empty}>
      {error ? <Close size={12} /> : !empty && <Checkmark size={12} />}
    </Circle>
    <Label>{label}</Label>
  </Box>
);

export default ChecklistItem;

const Circle = styled('div')<{ error?: boolean; empty?: boolean }>`
  border-radius: 12px;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, empty }) => (empty ? theme.vars.palette.beige : theme.vars.palette.greenColor)};
  color: white;
`;

const Box = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const Label = styled('span')`
  ${({ theme }) => styleToCss(theme.typography['body-sm'])};
  color: ${({ theme }) => theme.vars.palette.grey1};
`;
